import { useStationsFinder } from '@app/core/stations/hooks/useStations';
import { useFragmentQuery } from '@app/modules/fragments/hooks/useFragment';
import { useParams } from 'react-router';

export function useFragment() {
  const { fragmentId } = useParams<{ fragmentId: string }>();
  const fragmentQuery = useFragmentQuery(fragmentId!);

  const finder = useStationsFinder();

  if (!fragmentQuery.data) {
    throw new Error(`Fragment with id ${fragmentId} not loaded`);
  }

  const station = finder(fragmentQuery.data.stationId)!;

  return {
    fragment: fragmentQuery.data,
    station,
  };
}
